import { Roles } from "../enums/Roles";

export const useSelectableRole = (role?: string): boolean => {
  const selectableRoles = [
    Roles.GridCell,
    Roles.Option,
    Roles.Row,
    Roles.Tab,
    Roles.ColumnHeader,
    Roles.RowHeader,
    Roles.TreeItem,
  ];
  return selectableRoles.includes(role as Roles);
};
export const useCheckableRole = (role?: string): boolean => {
  const checkableRoles = [
    Roles.Checkbox,
    Roles.MenuItemCheckbox,
    Roles.Radio,
    Roles.MenuItemRadio,
  ];
  return checkableRoles.includes(role as Roles);
};
